import React, {Fragment, useEffect, useMemo, useRef, useState} from 'react';
import {useSelector} from "react-redux";
import {selectDateFormat, selectLang, selectNumberFormat} from "../../../../../store/reducers/main/main";
import {
    deletePurchasePayoutAsync,
    purchaseApproveAsync, purchaseChangeContractorAsync, purchaseDeleteItemAsync,
    purchasePayoutRegisterAsync,
    purchasePayoutUpdateAsync,
    purchaseUpdateDateAsync,
    purchaseUpdateItemAsync,
    purchaseUpdateNumberAsync,
    selectPurchaseDefaultsSettings
} from "../../../../../store/reducers/warehouse/purchaseReducer";
import {selectAllContractor} from "../../../../../store/reducers/contractor/contractorReducer";
import {selectCurrency} from "../../../../../store/reducers/currency/currencyReducer";
import {selectWarehouses} from "../../../../../store/reducers/warehouse/warehouseReducer";
import {selectItems} from "../../../../../store/reducers/item/itemReducer";
import {Controller, useFormContext, useWatch} from "react-hook-form";
import {Translate} from "../../../../../lang/lang";
import {useNavigate} from "react-router-dom";
import {Card, Col, Row, Form, InputGroup, Table, FloatingLabel, Spinner} from "react-bootstrap";
import IconArrowLeft from "../../../../../assets/icon/IconArrowLeft";
import {scrollEvent} from "../../../../../helpers/scrollEvent";
import IconButton from "../../../../IconButton";
import IconPlus from "../../../../../assets/icon/IconPlus";
import DatePickerComponent from "../../../../common/DatePickerComponent";
import classNames from "classnames";
import dayjs from "dayjs";
import EventBus from "../../../../../eventbus/EventBus";
import {ADD_CONTRACTOR_SUCCESS} from "../../../../../eventbus/contractor/contractorEvents";
import {ADD_EMPLOYEE_SUCCEED} from "../../../../../eventbus/employee/employeeEvent";
import {SCAN_SUCCESS} from "../../../../../eventbus/itemEvents";
import toast from "react-hot-toast";
import ContractorSelect from "../../../../contractor/ContractorSelect";
import WarehouseOperationWarehouseSelect from "../../WarehouseOperationWarehouseSelect";
import PurchaseModal from "../PurchaseModal";
import WarehouseOperationItemSelect from "../../WarehouseOperationItemSelect";
import WarehouseOperationImageModal from "../../WarehouseOperationImageModal";
import numeral from "numeral";
import WOExactDiscountPayment from "../WOExactDiscountPayment";
import Badge from "../../../../common/Badge";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrashAlt} from "@fortawesome/free-solid-svg-icons";
import WarehouseOperationFooterCurrencyTotalSum from "../../WarehouseOperationFooterCurrencyTotalSum";
import {useMainLayoutContext} from "../../../../../pheonix/providers/MainLayoutProvider";

const colIndexItem = 0
const colIndexQuantity = 2
const colIndexPrice = 3
const colIndexTotal = 4
const colIndexWarehouse = 6


const colCoordinateZero = 0
const rowCoordinateOne = 1
const subRowoordinateTwo = 2

const PurchaseForm = ({purchase, loading, loadingMore, addItem, isEditing}) => {

    const purchaseDefaultsSettings = useSelector(selectPurchaseDefaultsSettings)
    const numberFormat = useSelector(selectNumberFormat)
    const contractors = useSelector(selectAllContractor)
    const currencies = useSelector(selectCurrency)
    const dateFormat = useSelector(selectDateFormat)
    const warehouses = useSelector(selectWarehouses)
    const navigate = useNavigate()
    const items = useSelector(selectItems)
    const form = useFormContext()
    const lang = useSelector(selectLang)
    const t = Translate

    // state
    const [categoryItems, setCategoryItems] = useState(null)
    const [isHover, setIsHover] = useState([])
    const [filter, setFilter] = useState('')
    const [item, setItem] = useState(null)
    const [loadingContractor, setLoadingContractor] = useState(false)
    const {errors} = form?.formState

    // watch
    const packageMeasurements = useWatch({name: 'package_measurements', exact: true})
    const contractorId = useWatch({name: 'contractor_id', exact: true})
    const warehouseId = useWatch({name: 'warehouse_id', exact: true})
    const numberWatch = useWatch({name: 'number', exact: true})
    const commonPrice = form.watch('commonPrice')
    const warehouse = form.watch('warehouse')
    const quantity = form.watch('quantity')
    const itemId = useWatch({name: 'item_id', exact: true})

    const totalSum = +quantity * (+packageMeasurements?.quantity || 0) * +commonPrice?.amount
    const totalSumCurrencyName = currencies?.find(x => x.id === commonPrice?.currency_id)?.name
    const contractor = contractors?.find(x => x.id === contractorId)

    const {loading: contextLoading} = useMainLayoutContext();

    useEffect(() => {
        if (!contractor) {
            form?.setValue("contractor_id", purchaseDefaultsSettings?.defaultClientId)
        }

        if (!warehouseId) {
            form?.setValue("warehouse_id", purchaseDefaultsSettings?.defaultWarehouseId)
        }

        const onContractorAddedHandler = EventBus.on(ADD_CONTRACTOR_SUCCESS, (res) => {
            form?.setValue("contractor_id", res?.id)
        })
        const onEmployeeAddedHandler = EventBus.on(ADD_EMPLOYEE_SUCCEED, (res) => {
            form?.setValue("employee_id", res?.data?.id)
        })
        const onScanSuccessHandler = EventBus.on(SCAN_SUCCESS, onScan);

        return () => {
            EventBus.remove(SCAN_SUCCESS, onScanSuccessHandler);
            EventBus.remove(ADD_CONTRACTOR_SUCCESS, onContractorAddedHandler)
            EventBus.remove(ADD_EMPLOYEE_SUCCEED, onEmployeeAddedHandler)
        }
    }, [purchaseDefaultsSettings])

    useEffect(() => {
        form?.setValue("employee_id", purchaseDefaultsSettings?.defaultEmployeeId)
    }, [purchaseDefaultsSettings?.defaultEmployeeId]);

    useEffect(() => {
        if (warehouses?.length === 1 && warehouse) {
            form?.setValue("warehouse_id", warehouse[0]?.id)
        }
    }, [warehouse])

    const onScan = (value) => {
        if (value.length > 14) {
            const quantityGet = form?.getValues('quantity')

            form?.setValue('marks', [value])
            form?.setValue('quantity', +quantityGet + 1)

            addItem("addOrEditPurchase")
        }
    }

    const onChangeCategory = (option) => {
        setCategoryItems(items.filter(i => i?.item?.category?.id === option?.id))
    }

    const onChangeItem = (option) => {
        form.setValue('warehouse', option ? option?.warehouse_states?.warehouse_items : null)
    }

    // focus start
    const onFocusContractor = () => {
        if (!contractorId && !quantity && !itemId) {
            return true
        }
    }

    const onFocusItem = () => {
        if (contractorId && !itemId) {
            return true
        }
    }

    const onFocusWarehouse = () => {
        if (itemId && !warehouseId) {
            return true
        }
    }

    const onFocusQuantity = () => {
        if (warehouseId && itemId && contractorId && !quantity) {
            document.getElementById('quantity')?.focus()
            return true
        }
    }

    useEffect(() => {
        onFocusQuantity()

        // set purchase price
        if (warehouseId) {
            const purchasePrice = item?.warehouse_states?.warehouse_items?.filter(x => x.purchase_price?.price)
            const findByWarehouse = purchasePrice?.find(x => x.id === warehouseId)
            if (findByWarehouse) {
                form.setValue('commonPrice.amount', findByWarehouse?.purchase_price?.price?.amount)
                form.setValue('commonPrice.currency_id', findByWarehouse?.purchase_price?.price?.currency?.id)
            } else if (purchasePrice) {
                form.setValue('commonPrice.amount', 0)
                form.setValue('commonPrice.currency_id', 0)
            }
        }
    }, [warehouseId, itemId])

    // payout start
    const onSubmitPay = async (pay) => {
        if (purchase?.payout) {
            await purchasePayoutUpdateAsync({purchaseId: pay?.id, payout: pay?.payment})
                .then(() => {
                })
                .catch(() => {

                })
        }

        if (!purchase?.payout && purchase?.is_approved) {
            await purchasePayoutRegisterAsync({purchaseId: pay?.id, payout: pay?.payment})
                .then(() => {
                })
                .catch(() => {

                })

        }

        if (!purchase?.is_approved) {
            await purchaseApproveAsync({purchaseId: pay?.id, payout: pay?.payment || null})
                .then(() => {
                })
                .catch(() => {

                })
        }
    }

    // payout end


    const data = useMemo(() => {
        return purchase?.items?.filter(i => {
            const searchLower = filter.trim().toLowerCase();

            // search by barcode
            {
                if (searchLower.length >= 8 && searchLower.length <= 13 && !isNaN(searchLower)) {
                    const searchBarcode = items.filter(it => it.item?.barcodes?.some((b) => b?.includes(searchLower)))

                    if (searchBarcode.some(bar => bar?.item?.name.trim().toLowerCase() === i?.warehouse_item?.name.trim().toLowerCase()))
                        return true;
                }
            }

            // search by name
            {
                const filterNameParts = searchLower.replaceAll('  ', ' ').split(' ');
                const itemLowerName = i.warehouse_item?.name.toLowerCase();
                if (filterNameParts?.length === filterNameParts?.filter(fnp => itemLowerName?.indexOf(fnp) > -1)?.length)
                    return true;
            }
        })
    }, [purchase, filter])

    const groupByItemIdAndPrice = (filterItems) => {
        var groupByItemIdPriceIdCurrencyId = {}

        filterItems?.forEach((item) => {
            const itemID = item?.warehouse_item?.id;
            const currencyID = item?.price?.currency?.id;
            const amount = item?.price?.amount;

            const key = `${itemID}_${currencyID}_${amount}`

            if (key in groupByItemIdPriceIdCurrencyId) {
                groupByItemIdPriceIdCurrencyId[key].sub.push(item)
            } else {
                if (key) {
                    groupByItemIdPriceIdCurrencyId[key] = {
                        item: {
                            id: item?.warehouse_item?.id,
                            name: item?.warehouse_item?.name
                        },
                        sub: [item]
                    }
                }
            }

        })

        return Object.values(groupByItemIdPriceIdCurrencyId)
    }
    const groupByItemPriceCurrencyId = groupByItemIdAndPrice(data?.filter(f => !f?.is_deleted))

    // hover mouser over
    const handleMouseOver = ({col, row, subRow}) => {
        setIsHover([col, row, subRow])
    }

    const updateItem = async ({itemOne, quantity, price, totalSum, warehouseId, item}) => {
        const operationItem = {
            operation_item_id: item?.id,
            item_id: item?.warehouse_item?.id,
            warehouse_id: item?.warehouse_item?.warehouse?.id,
            quantity: item?.quantity,
            price: {
                amount: item?.price?.amount,
                currency_id: item?.price?.currency?.id,
            },
        }


        if (itemOne) {
            operationItem.item_id = itemOne?.item?.id
            operationItem.price.amount = itemOne?.price?.common_price.amount
            operationItem.price.currency_id = itemOne?.price?.common_price?.currency?.global_currency_id
        }
        if (quantity) {
            operationItem.quantity = +quantity
        }
        if (price) {
            operationItem.price.amount = +price
        }
        if (totalSum) {
            operationItem.quantity = +(+totalSum / item?.price?.amount).toFixed(2)
        }
        if (warehouseId) {
            operationItem.warehouse_id = warehouseId
        }

        await purchaseUpdateItemAsync({
            purchaseId: purchase?.id,
            operation: operationItem
        })
            .then(() => {
                toast.success(t(lang, "warehouse.operation.item.common.update.toast.success"))
            })
            .catch(() => {
                toast.error(t(lang, "warehouse.operation.item.common.update.toast.error"))
            })
            .finally(() => {
                setIsHover([])

            })
    }

    // delete item
    const onDeleteItem = async ({id, itemId}) => {
        await purchaseDeleteItemAsync({purchaseId: id, operationId: itemId})
            .then((response) => {
                toast.success(t(lang, "warehouse.operation.item.common.toast.success"))
            })
            .catch((error) => {
                toast.error(t(lang, "warehouse.operation.item.common.toast.error"))
            })
    }
    const onDateChanged = async (e, date) => {
        if (e === "Save") {
            await purchaseUpdateDateAsync({
                purchaseId: purchase?.id,
                date: date ? dayjs(date).format("YYYY-MM-DD HH:mm:ss") : dayjs(purchase?.date).format("YYYY-MM-DD HH:mm:ss")
            })
                .then(() => {
                    form.setValue('date', date ? dayjs(date, "YYYY-MM-DD HH:mm").toDate() : dayjs(purchase?.date, "YYYY-MM-DD HH:mm").toDate())
                    toast.success(t(lang, "warehouse.operation.item.common.toast.success"))
                })
                .catch(() => {
                    toast.error(t(lang, "warehouse.operation.item.common.toast.error"))
                })
        }
        if (e === "Cancel") {
            form.setValue('date', dayjs(purchase?.date, "YYYY-MM-DD HH:mm").toDate())
        }
    }

    const onNumberChanged = (e, number) => {
        if (e === "Save") {
            if (number?.trim() && number !== purchase?.number) {
                purchaseUpdateNumberAsync({purchaseId: purchase?.id, number: number})
                    .then(() => {
                        form.setValue('number', number ? number : purchase?.number)
                        toast.success(t(lang, "warehouse.operation.item.common.toast.success"))
                    })
                    .catch(() => {
                        toast.error(t(lang, "warehouse.operation.item.common.toast.error"))
                    })
            }
        }
        if (e === "Cancel") {
            form.setValue('number', purchase?.number)
        }
    }

    const deletePurchasePayout = (purchaseId) => {
        deletePurchasePayoutAsync(purchaseId)
            .then(() => toast.success(t(lang, 'common.toast.success')))
            .catch(() => toast.error(t(lang, 'common.toast.error')))
    }

    const onContractorChanged = async (e, value, setValue, defaultValue) => {
        if (e === 'Save') {
            setLoadingContractor(true)
            await purchaseChangeContractorAsync({purchaseId: purchase.id, contractorId: value?.id})
                .then(() => {
                    toast.success(t(lang, "warehouse.operation.item.common.toast.success"))
                    form.setValue('contractor_id', value?.id)
                })
                .catch(() => {
                    toast.error(t(lang, "warehouse.operation.item.common.toast.error"))
                })
                .finally(() => {
                    setLoadingContractor(false)
                })
        } else {
            setValue(contractors.find(i => i.id === defaultValue))
        }
    }

    const childRef = useRef();
    const handleSubmit = () => {
        if (childRef.current) {
            childRef.current();
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', () => scrollEvent('warehouse-purchase-register'));
        return () => window.removeEventListener('scroll', () => scrollEvent('warehouse-purchase-register'))
    }, []);

    return (
        <Fragment>
            <Row id={'warehouse-purchase-register'}
                 className="flex-between-center align-items-center my-3 position-sticky" style={{top: '4rem'}}>
                <Col cols={'auto'} className={'d-flex gap-3'}>
                    <button onClick={() => navigate(-1)} className={'main-text btn-back'}
                            style={{width: 35, height: 35}}>
                        <IconArrowLeft/>
                    </button>
                    <div>
                        <h5 className="fs-8 mb-0 text-nowrap py-2 py-xl-0">{t(lang, "warehouse.operation.item.common.new_coming")}</h5>
                        <span className={'second-text fs-9'}>{t(lang, 'warehouse.navbar.routes.warehouse')}</span>
                    </div>
                </Col>
                <Col cols={'auto'} className={'d-flex align-items-center justify-content-end gap-2 flex-wrap'}>
                    <IconButton
                        size="sm"
                        variant="falcon-primary"
                        className="btn-primary-davr"
                        onClick={handleSubmit}
                        disabled={!purchase?.items?.length}
                    >
                        {contextLoading ?
                            <Spinner className="align-middle me-2" animation="border" role="switch" size="sm"/> :
                            <IconPlus/>
                        }
                        <span className="d-none d-sm-inline-block ms-1 fs-8 text-white text-nowrap fs-md-9">
                            {t(lang, "items.common.save")}
                        </span>
                    </IconButton>
                </Col>
            </Row>

            <Card className={'p-1'}>
                <Row>
                    <Form.Group as={Col} xs={12} lg={4}>
                        <Controller
                            name={'date'}
                            rules={{
                                required: t(lang, 'warehouse.operation.item.common.validation.is_required'),
                            }}
                            render={({field}) => (
                                <InputGroup className={'select'}>
                                    <DatePickerComponent
                                        field={field}
                                        placeholderText={<>
                                            {t(lang, "Дата")}
                                            <span className={'text-primary-davr'}>*</span>
                                        </>}
                                        dateFormat={`${dateFormat} HH:mm`}
                                        showTimeSelect
                                        timeFormat="p"
                                        timeIntervals={60}
                                        wrapperClassName={classNames({
                                            'is-invalid': errors?.date
                                        })}
                                        className={classNames('form-control', {
                                            'is-invalid': errors?.date,
                                        })}
                                    />
                                    {dayjs(field?.value).format("YYYY-MM-DD HH:mm:ss") !== purchase?.date && purchase &&
                                        <Fragment>
                                            <IconButton
                                                variant={"falcon-info"}
                                                title={"Save"}
                                                size="md"
                                                onClick={(e) => onDateChanged("Save", field?.value)}
                                                icon={"check"}
                                            />
                                            <IconButton
                                                variant="danger"
                                                title={"Cancel"}
                                                size="md"
                                                onClick={(e) => onDateChanged("Cancel")}
                                                icon="cancel"
                                            />
                                        </Fragment>
                                    }
                                </InputGroup>
                            )}/>
                        <Form.Control.Feedback type="invalid">
                            {errors?.date?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} xs={12} lg={4}>
                        <Controller
                            name="contractor_id"
                            rules={{
                                required: t(lang, "warehouse.operation.item.common.validation.is_required")
                            }}
                            render={({field}) => {
                                return (
                                    <ContractorSelect
                                        right={true}
                                        onFocus={onFocusContractor()}
                                        placeholder={<>
                                            <span>{t(lang, "warehouse.operation.item.common.executor")}</span>
                                            <span className={'text-primary-davr'}>*</span>
                                        </>}
                                        defaultValue={field?.value}
                                        onChange={(option) => {
                                            field.onChange(option ? option?.id : null)
                                        }}
                                        isClearable={true}
                                        allowAdd={true}
                                        allowEdit={true}
                                        className={classNames({
                                            'is-invalid': errors?.contractor_id,
                                        })}
                                        isEditing={groupByItemPriceCurrencyId.length > 0 && true || isEditing}
                                        changeContractor={onContractorChanged}
                                        loading={loadingContractor}
                                    />
                                )
                            }}
                        />
                        <Form.Control.Feedback type="invalid" className="d-block">
                            {errors?.contractor_id?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} xs={12} lg={4}>
                        <Controller
                            name="warehouse_id"
                            rules={{
                                required: t(lang, "warehouse.operation.item.common.validation.is_required")
                            }}
                            render={({field}) => {
                                return (
                                    <WarehouseOperationWarehouseSelect
                                        placeholder={<>
                                            {t(lang, 'warehouse.navbar.routes.warehouse')}
                                            <span className={'text-primary-davr'}>*</span>
                                        </>}
                                        defaultValue={field?.value}
                                        options={warehouse}
                                        onChange={(option) => {
                                            field.onChange(option ? option?.id : null)
                                        }}
                                        className={classNames({
                                            'is-invalid': errors?.warehouse_id
                                        })}
                                    />
                                )
                            }}
                        />
                        <Form.Control.Feedback type="invalid" className="d-block">
                            {errors?.warehouse_id?.message}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Row>
            </Card>

            <Card className={'p-1 mt-2'}>
                <Table
                    responsive
                    className="scrollbar view-table border-900 mb-0 fs-9 second-text fw-semi-bold"
                    style={{maxHeight: "560px"}}
                >
                    <thead className="text-dark border-bottom">
                    <tr>
                        <th className="fw-medium  align-middle text-center">№</th>
                        <th className="fw-medium  align-middle text-center" style={{width: "300px"}}>
                            {t(lang, "warehouse.operation.item.common.name")}
                        </th>
                        {/* <th className="fw-medium  align-middle text-center">
                            {t(lang, "warehouse.operation.item.common.image")}
                        </th>*/}
                        <th className="fw-medium  align-middle text-center">
                            {t(lang, "warehouse.operation.item.common.quantity")}
                        </th>
                        <th className="fw-medium  align-middle text-center" style={{width: "300px"}}>
                            {t(lang, "warehouse.operation.item.common.selling_price")}
                        </th>
                        <th className="fw-medium  align-middle text-center">
                            {t(lang, "warehouse.operation.item.common.total")}
                        </th>
                        {purchase?.items?.some(item => item?.warehouse_item?.warehouse_item_use) &&
                            <th className="fw-medium  align-middle text-center">
                                {t(lang, "warehouse.operation.item.common.remainder_change")}
                            </th>
                        }
                        {warehouses?.length > 1 &&
                            <th className="fw-medium  align-middle text-center" style={{width: "230px"}}>
                                {t(lang, "warehouse.operation.item.common.warehouse_name")}
                            </th>
                        }
                        <th>
                            <PurchaseModal
                                categoryItems={categoryItems}
                                onChangeItem={onChangeItem}
                                commonPrice={commonPrice}
                                setItem={setItem}
                                loading={loading}
                                loadingMore={loadingMore}
                                warehouseId={warehouseId}
                                itemId={itemId}
                                quantity={quantity}
                                addItem={addItem}
                            />
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {groupByItemPriceCurrencyId?.map((item, rowIndex) => {
                        return (
                            <Fragment key={rowIndex}>
                                {item?.sub?.map((subItem, subRowIndex) => {
                                    return (
                                        <tr key={subItem.id} className="fw-bold" style={{height: "62px"}}>
                                            <td key={rowIndex}
                                                className={subRowIndex === 0 ? "text-start ps-3" : "d-none"}
                                                rowSpan={item?.sub?.length}
                                                style={{width: "50px"}}
                                            >
                                                {groupByItemPriceCurrencyId?.length - rowIndex}
                                            </td>
                                            <td className={subRowIndex === 0 ? "text-start" : "d-none"}
                                                rowSpan={item?.sub?.length}
                                                style={{minWidth: "300px"}}
                                                onDoubleClick={() => handleMouseOver({
                                                    col: colIndexItem,
                                                    row: rowIndex,
                                                    subRow: subRowIndex
                                                })}
                                            >
                                                {isHover[colCoordinateZero] === colIndexItem && isHover[rowCoordinateOne] === rowIndex && isHover[subRowoordinateTwo] === subRowIndex ?
                                                    <WarehouseOperationItemSelect
                                                        placeholder={t(lang, "warehouse.operation.item.common.product_name")}
                                                        options={items}
                                                        defaultValue={subItem?.warehouse_item?.id}
                                                        menuPortalTarget={document.body}
                                                        onChange={option => {
                                                            updateItem({
                                                                itemOne: option,
                                                                item: subItem
                                                            })
                                                        }}
                                                    />
                                                    :
                                                    <>
                                                        {subItem?.warehouse_item?.name}
                                                    </>
                                                }
                                            </td>
                                            {/*<td className={subRowIndex === 0 ? "text-center border-end border-2" : "d-none"}
                                                style={{width: "50px"}}
                                                rowSpan={item?.sub?.length}
                                            >
                                                {items.find(i => i?.item?.id === subItem?.warehouse_item?.id)?.item?.images?.length > 0 &&
                                                    <WarehouseOperationImageModal
                                                        image={items.find(i => i?.item?.id === item?.item?.id)?.item?.images}/>
                                                }
                                            </td>*/}
                                            <td className="text-start"
                                                style={{maxWidth: "100px"}}
                                                onDoubleClick={() => handleMouseOver({
                                                    col: colIndexQuantity,
                                                    row: rowIndex,
                                                    subRow: subRowIndex
                                                })}>
                                                {isHover[colCoordinateZero] === colIndexQuantity && isHover[rowCoordinateOne] === rowIndex && isHover[subRowoordinateTwo] === subRowIndex ?
                                                    <FloatingLabel
                                                        label={t(lang, "warehouse.operation.item.common.quantity")}>
                                                        <Form.Control
                                                            placeholder={t(lang, "Quantity")}
                                                            defaultValue={subItem?.quantity}
                                                            onFocus={(e) => e.target.select()}
                                                            autoFocus
                                                            onBlur={(e) => {
                                                                updateItem({
                                                                    quantity: e.target.value,
                                                                    item: subItem,
                                                                })
                                                            }}
                                                        />
                                                    </FloatingLabel>
                                                    :
                                                    <>
                                                        {subItem?.quantity}
                                                    </>
                                                }
                                            </td>
                                            <td className="text-start text-nowrap"
                                                style={{width: "200px"}}
                                                onDoubleClick={() => handleMouseOver({
                                                    col: colIndexPrice,
                                                    row: rowIndex,
                                                    subRow: subRowIndex
                                                })}>
                                                {isHover[colCoordinateZero] === colIndexPrice && isHover[rowCoordinateOne] === rowIndex && isHover[subRowoordinateTwo] === subRowIndex ?
                                                    <FloatingLabel
                                                        label={t(lang, "warehouse.operation.item.common.selling_price")}>
                                                        <Form.Control
                                                            placeholder={t(lang, "Price")}
                                                            defaultValue={subItem?.price?.amount}
                                                            onFocus={(e) => e.target.select()}
                                                            autoFocus
                                                            onBlur={(e) => {
                                                                updateItem({
                                                                    price: e.target.value,
                                                                    item: subItem,
                                                                })
                                                            }}
                                                        />
                                                    </FloatingLabel>
                                                    :
                                                    <>
                                                        {numeral.formats[numberFormat].format(subItem?.price?.amount)}
                                                        <span
                                                            className="text-info"> {subItem?.price?.currency?.name}</span>
                                                    </>
                                                }
                                            </td>
                                            <td className="text-start text-nowrap"
                                                style={{width: "300px"}}
                                                onDoubleClick={() => handleMouseOver({
                                                    col: colIndexTotal,
                                                    row: rowIndex,
                                                    subRow: subRowIndex
                                                })}>
                                                {isHover[colCoordinateZero] === colIndexTotal && isHover[rowCoordinateOne] === rowIndex && isHover[subRowoordinateTwo] === subRowIndex ?
                                                    <FloatingLabel
                                                        label={t(lang, "warehouse.operation.item.common.total")}>
                                                        <Form.Control
                                                            placeholder={t(lang, "total sum")}
                                                            defaultValue={subItem?.quantity * subItem?.price?.amount}
                                                            onFocus={(e) => e.target.select()}
                                                            autoFocus
                                                            onBlur={(e) => {
                                                                updateItem({
                                                                    totalSum: +e.target.value,
                                                                    item: subItem,
                                                                })
                                                            }}
                                                        />
                                                    </FloatingLabel>
                                                    :
                                                    <>
                                                        {numeral.formats[numberFormat].format(subItem?.quantity * subItem?.price?.amount)}
                                                        <span
                                                            className="text-info"> {subItem?.price?.currency?.name}</span>
                                                    </>
                                                }
                                            </td>
                                            {groupByItemPriceCurrencyId[rowIndex]?.sub?.some(s => s?.warehouse_item?.warehouse_item_use) &&
                                                <td className="text-center text-nowrap">
                                                    {subItem?.warehouse_item?.warehouse_item_use?.before_quantity}
                                                    <span> => </span>
                                                    {subItem?.warehouse_item?.warehouse_item_use?.after_quantity}
                                                </td>
                                            }
                                            {warehouses?.length > 1 &&
                                                <td className="text-start"
                                                    style={{width: "240px"}}
                                                    onDoubleClick={() => handleMouseOver({
                                                        col: colIndexWarehouse,
                                                        row: rowIndex,
                                                        subRow: subRowIndex
                                                    })}>
                                                    {isHover[colCoordinateZero] === colIndexWarehouse && isHover[rowCoordinateOne] === rowIndex && isHover[subRowoordinateTwo] === subRowIndex && warehouses?.length > 1 ?
                                                        <WarehouseOperationWarehouseSelect
                                                            placeholder={t(lang, "warehouse.operation.item.common.warehouse_name")}
                                                            options={items?.find(f => f?.warehouse_states?.id === subItem?.warehouse_item?.id)?.warehouse_states?.warehouse_items}
                                                            defaultValue={subItem?.warehouse_item?.warehouse?.id}
                                                            onFocus={() => true}
                                                            autoFocus={true}
                                                            onBlur={(warehouse) => {
                                                                updateItem({
                                                                    warehouseId: warehouse?.id,
                                                                    item: subItem,
                                                                })
                                                            }}
                                                            onChange={warehouse => {
                                                                updateItem({
                                                                    warehouseId: warehouse?.id,
                                                                    item: subItem,
                                                                })
                                                            }}
                                                        />
                                                        :
                                                        <>
                                                            {subItem?.warehouse_item?.warehouse?.name}
                                                        </>
                                                    }
                                                </td>
                                            }

                                            <td className="text-nowrap text-center"
                                                style={{width: "40px"}}>
                                                {subItem?.is_deleted &&
                                                    <span className="text-end text-nowrap text-danger">
                                                                        {t(lang, "warehouse.operation.item.common.removed")}
                                                                    </span>
                                                }

                                                <Badge
                                                    className={'px-2 py-2 fs-8 rounded-3 cursor-pointer'}
                                                    bg="danger-davr"
                                                    variant="phoenix"
                                                    onClick={() => onDeleteItem({
                                                        id: purchase?.id,
                                                        itemId: subItem?.id
                                                    })}
                                                >
                                                    <FontAwesomeIcon icon={faTrashAlt}/>
                                                </Badge>
                                            </td>
                                        </tr>
                                    )
                                })}
                            </Fragment>
                        )
                    })}
                    </tbody>
                </Table>
                {purchase?.items?.length && <WarehouseOperationFooterCurrencyTotalSum
                    netPriceType={"debtHidden"}
                    netPrice={purchase?.net_price}
                    pay={purchase?.payout}
                />}
            </Card>

            {
                purchase?.items?.length && <Card className={'p-1 mt-2'}>
                    <WOExactDiscountPayment
                        ref={childRef}
                        data={purchase}
                        isEditing={isEditing}
                        onSubmitPay={onSubmitPay}
                    />
                </Card>
            }
        </Fragment>
    );
};

export default PurchaseForm;
